import { AdminUserService } from '@services/admin-user-service';
import { ErrorResponse } from '@models/error.response';
import { NgForm } from '@angular/forms';
import { Role } from '@models/role';
import { FormValidationUtil } from '@utils/form.validation';
import { AdminUser } from '@models/admin-user';
import { of, from } from 'rxjs';
import { AppConstant } from '@constants/app.constant';
import { TranslateService } from '@ngx-translate/core';
import { MainComponent } from '../main/main.component';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { RoleService } from '@services/role.service';
import { ActionType } from '@type/action.type';
import { Component, ViewChild } from '@angular/core';
import swal from 'sweetalert2';
import { switchMap, map, mergeMap, reduce } from 'rxjs/operators';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { CommonService } from '@app/services/common.service';
import { CommonResponse } from '@app/models/common-model';
import { MerchantAdminUserService } from '@app/services/merchant-user.service';
import { AppModule } from '@app/app.module';

const phoneUtil = PhoneNumberUtil.getInstance();


@Component({
    templateUrl: './merchant-admin-user-setup.component.html',
    styleUrls: ['./merchant-admin-user-setup.component.scss']
})

export class MerchantAdminUserSetupComponent {

    searchRole = Role.search;

    @ViewChild('adminUserForm', { static: false }) adminUserForm: NgForm;

    action: ActionType;
    adminUser: AdminUser;
    isFieldError = FormValidationUtil.isFieldError;
    roleOptions: Role[] = [];

    selectedSuperivor: AdminUser;
    password: string = '';
    confirmPassword: string = '';

    loading: boolean = false;
    clickedSave: boolean = false;
    isPasswordHasUsername: boolean = false;
    isConfirmPasswordNotEqual: boolean = false;
    isConfirmPasswordHasUsername: boolean = false;
    isAllowCreateNewUser: boolean = false;
    
    isPhoneNoValid: boolean = true;
    userEmailhadBeenDefined: string = '';


    constructor(
        private roleService: RoleService,
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent,
        private translate: TranslateService,
        private commonService: CommonService,
        public appConstant: AppConstant,
        public adminUserService: MerchantAdminUserService) {
    }

    ngOnInit(): void {
        this.adminUser = new AdminUser();
        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.loading = true;
                    if (params['id'] === 'new') {
                        this.action = 'CREATE';
                    } else {
                        this.action = 'EDIT';
                    }
                    return of(params);
                }),
                switchMap((params: Params) => {
                    return this.adminUserService.checkAllowNewUserCreate()
                        .pipe(
                            map((resp:CommonResponse) => {
                                this.isAllowCreateNewUser = resp.content.status=='TRUE';
                                return params;
                            })
                        );
                }),
                switchMap((params: Params) => {
                    return this.roleService.getRoleByType('ADMIN')
                        .pipe(
                            map(roles => {
                                this.roleOptions = roles;
                                return params;
                            })
                        );
                }),
                switchMap((params: Params) => {
                    if (this.action == 'CREATE') {
                        var adminUser = new AdminUser();
                        var currentUser = this.commonService.getCurrentUser();
                        adminUser.companyCode = currentUser.companyCode;
                        adminUser.companyDescription = currentUser.companyDescription;
                        adminUser.companyEmail = currentUser.companyEmail;
                        adminUser.companyName = currentUser.companyName;
                        adminUser.companyPhone = currentUser.companyPhone;
                        adminUser.orderNoPrefix = currentUser.orderNoPrefix;
                        adminUser.companyShortName = currentUser.companyShortName;
                        for(var ix=0; ix<this.roleOptions.length; ix++){
                            var rr = this.roleOptions[ix];
                            if(rr.roleCode=='MerchantRole'){
                                adminUser.roles[0] = rr; 
                                break;
                            }
                        }
                        return of(adminUser);
                    } else {
                        return this.adminUserService.get(params['id']);
                    }
                })
            )
            .subscribe((adminUser: AdminUser) => {
                this.adminUser = adminUser;
                this.loading = false;
            });
       
    }

    setSelectedUser(users) {
        if (users.length > 0) {
            this.adminUser.supervisor = users[0];
        } else {
            this.adminUser.supervisor = null;
        }
    }

    showAddUpdateButton():boolean{
       return (this.action == 'EDIT' && this.commonService.hasAuthority('PERM_MERCHANT_USER_UPDATE')) 
       || (this.action == 'CREATE' && this.commonService.hasAuthority('PERM_MERCHANT_USER_CREATE'))
    }

    save() {
        this.clickedSave = true;

        // if( this.adminUser.supervisor != null){
        //     delete  this.adminUser.supervisor.authorities;
        // }

        this.adminUserService.checkUniqueSettings(this.adminUser.userId, this.adminUser.username, this.adminUser.userEmail).subscribe((res: CommonResponse)=>{
            if(res.content.status=='VALID'){
                
                this.userEmailhadBeenDefined = '';
                this._save();

            }else{
                this.userEmailhadBeenDefined = res.content.errorCode;
                this.translate.get(ModulePathConstant.MERCHANT_USER_MODULE)
                .pipe(
                    switchMap(typeStr => this.translate.get(res.content.errorCode, { type: typeStr }))
                )
                .subscribe(res => {
                    swal.fire({
                        type: 'error',
                        title: res
                    });
                });
            }
        });
    }



    private _save(){
        

        //check form for just clicking save without any input
        for (let key of Object.keys(this.adminUserForm.controls)) {
            this.adminUserForm.controls[key].markAsDirty();
        }

        if (this.adminUserForm.valid &&
            this.isConfirmPasswordMatch() &&
            !this.isContainUsername(this.password) &&
            !this.isContainUsername(this.confirmPassword) &&
            !this.isInvalidPasswordComplexity(this.password) &&
            !this.isInvalidPasswordComplexity(this.confirmPassword) &&
            this.isPhoneNoValid) {

            if (this.isCompositedInputValid()) {
                switch (this.action) {
                    case 'CREATE':
                        debugger
                        this.adminUser.userPassword = this.password;
                        this.create();
                        break
                    case 'EDIT':
                        this.update();
                        break;
                }
            }
        }

    }

    private isCompositedInputValid() {
        return (!this.isPasswordHasUsername
            && !this.isConfirmPasswordNotEqual
            && !this.isConfirmPasswordHasUsername);
    }

    private create(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.adminUserService.insert(this.adminUser)
            .subscribe(() => {
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.MERCHANT_USER_PATH]);

                this.translate.get(ModulePathConstant.MERCHANT_USER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_ADDED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });
            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;
                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.MERCHANT_USER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_ADD, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });
                        });
                });
    }

    private update(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.adminUserService.update(this.adminUser)
            .subscribe(user => {
                this.adminUser = user;
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.MERCHANT_USER_PATH]);

                this.translate.get(ModulePathConstant.MERCHANT_USER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_UPDATED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });

            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;


                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.MERCHANT_USER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_UPDATE, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });
                        });
                })

    }


    cancel(): void {
        this.router.navigate([ModulePathConstant.MERCHANT_USER_PATH]);
    }

    isConfirmPasswordMatch(): boolean {

        if (this.confirmPassword != null
            && this.confirmPassword !== ''
            && this.password != null
            && this.password !== '') {

            if (this.confirmPassword !== this.password) {
                return false;
            }

        }

        return true;
    }

    isContainUsername(value): boolean {

        if (this.adminUser == null) {
            return false;
        }

        if (this.adminUser.username == null || this.adminUser.username == '') {
            return false;
        }

        if (value.toLowerCase().indexOf(this.adminUser.username.toLowerCase()) !== -1) {
            return true;
        } else {
            return false;
        }

    }

    isInvalidPasswordComplexity(value): boolean {

        if (value == null || value.trim() == '') {
            return false;
        }

        return !(new RegExp(this.appConstant.passwordComplexityRegex).test(value));
    }

    checkValidPhone() {
        if(!this.adminUser.contactNo && !this.adminUser.contactNoCountryCode) {
            this.isPhoneNoValid = true;
        }
        else
        {
            if ((!this.adminUser.contactNoCountryCode || this.adminUser.contactNoCountryCode.length == 0) && this.adminUser.contactNo != null) {
                this.isPhoneNoValid = false;
            } else if (this.adminUser.contactNoCountryCode.length != 0) {
                try {
                    const phoneNumber = phoneUtil.parse(this.adminUser.contactNo, phoneUtil.getRegionCodeForCountryCode(this.adminUser.contactNoCountryCode));
                    if (!phoneUtil.isValidNumber(phoneNumber)) {
                        this.isPhoneNoValid = false;
    
                    } else {
                        this.isPhoneNoValid = true;
                    }
                } catch (err) {
                    this.isPhoneNoValid = false;
                }
    
            }
        }
    }
}